// extracted by mini-css-extract-plugin
export var downArrow = "_j4-0";
export var infoTooltipIcon = "_j4-3";
export var label = "_j4-1";
export var optionCard = "_j4-4";
export var upArrow = "_j4-2";